// extracted by mini-css-extract-plugin
export var active = "GlobalSearch-module--active--eef3b";
export var cdsAssistiveText = "GlobalSearch-module--cds--assistive-text--797c8";
export var cdsVisuallyHidden = "GlobalSearch-module--cds--visually-hidden--f1d0e";
export var container = "GlobalSearch-module--container--5229c";
export var description = "GlobalSearch-module--description--6f61d";
export var hidden = "GlobalSearch-module--hidden--09bad";
export var hideFeedback = "GlobalSearch-module--hide-feedback--79de2";
export var inactive = "GlobalSearch-module--inactive--0984a";
export var input = "GlobalSearch-module--input--8bf37";
export var inputFocusWithin = "GlobalSearch-module--inputFocusWithin--d5f43";
export var inputWrapper = "GlobalSearch-module--inputWrapper--00568";
export var label = "GlobalSearch-module--label--1a9ba";
export var link = "GlobalSearch-module--link--7ade7";
export var list = "GlobalSearch-module--list--59b6a";
export var searchButton = "GlobalSearch-module--searchButton--877c5";
export var searchButtonClose = "GlobalSearch-module--search-button--close--1f3e3";
export var showFeedback = "GlobalSearch-module--show-feedback--06031";
export var skeleton = "GlobalSearch-module--skeleton--8bde4";
export var tab = "GlobalSearch-module--tab--eba0a";